// extracted by mini-css-extract-plugin
export default {"info":"dmstooltip_info__zM+x2","tooltip":"dmstooltip_tooltip__N19yN"};